import { apiClient } from './client'

// ServiceNow API types
export interface ServiceNowStatusResponse {
  configured: boolean
  message: string
}

export interface PublishRequest {
  display_number: string
  short_description?: string
  article_body?: string
  metatags?: string
  ai_summary?: string  // 100-char user-friendly summary for ServiceNow u_summary field
}

export interface PublishResponse {
  status: string
  message: string
  display_number: string
  servicenow_sys_id?: string
  details?: {
    checkout_sys_id?: string
    update_result?: unknown
    message?: string
  }
}

// ServiceNow API service
export const servicenowApi = {
  // Check ServiceNow integration status
  async getStatus(): Promise<ServiceNowStatusResponse> {
    const response = await apiClient.get('/v1/servicenow/status')
    return response.data
  },

  // Publish enhanced article to ServiceNow
  async publish(request: PublishRequest): Promise<PublishResponse> {
    const response = await apiClient.post('/v1/servicenow/publish', request)
    return response.data
  },

  // Publish by display number (convenience method)
  async publishByDisplayNumber(displayNumber: string): Promise<PublishResponse> {
    const encoded = encodeURIComponent(displayNumber)
    const response = await apiClient.post(`/v1/servicenow/publish/${encoded}`)
    return response.data
  },
}

export default servicenowApi
